module.exports = __webpack_public_path__ + "img/KJF-TagHollen(2).dde0f799.jpg";